import util from '../util';

export const ANALYTICS_OVERVIEW = 'ANALYTICS_OVERVIEW';
export const ANALYTICS_ONLINE = 'ANALYTICS_ONLINE';
export const ANALYTICS_STORE = 'ANALYTICS_STORE';
export const ANALYTICS_STORE_DEALS = 'ANALYTICS_STORE_DEALS';
export const ANALYTICS_ONLINE_DEALS = 'ANALYTICS_ONLINE_DEALS';
export const ANALYTICS_FEATURE_METRICS = 'ANALYTICS_FEATURE_METRICS';
export const ANALYTICS_OVERVIEW_REQUEST = util.requestType(ANALYTICS_OVERVIEW);
export const ANALYTICS_OVERVIEW_SUCCESS = util.successType(ANALYTICS_OVERVIEW);
export const ANALYTICS_OVERVIEW_FAILURE = util.failureType(ANALYTICS_OVERVIEW);

export const ANALYTICS_ONLINE_REQUEST = util.requestType(ANALYTICS_ONLINE);
export const ANALYTICS_ONLINE_SUCCESS = util.successType(ANALYTICS_ONLINE);
export const ANALYTICS_ONLINE_FAILURE = util.failureType(ANALYTICS_ONLINE);

export const ANALYTICS_STORE_REQUEST = util.requestType(ANALYTICS_STORE);
export const ANALYTICS_STORE_SUCCESS = util.successType(ANALYTICS_STORE);
export const ANALYTICS_STORE_FAILURE = util.failureType(ANALYTICS_STORE);

export const ANALYTICS_STORE_DEALS_REQUEST = util.requestType(
  ANALYTICS_STORE_DEALS,
);
export const ANALYTICS_STORE_DEALS_SUCCESS = util.successType(
  ANALYTICS_STORE_DEALS,
);
export const ANALYTICS_STORE_DEALS_FAILURE = util.failureType(
  ANALYTICS_STORE_DEALS,
);

export const ANALYTICS_ONLINE_DEALS_REQUEST = util.requestType(
  ANALYTICS_ONLINE_DEALS,
);
export const ANALYTICS_ONLINE_DEALS_SUCCESS = util.successType(
  ANALYTICS_ONLINE_DEALS,
);
export const ANALYTICS_ONLINE_DEALS_FAILURE = util.failureType(
  ANALYTICS_ONLINE_DEALS,
);

export const ANALYTICS_FEATURE_METRICS_REQUEST = util.requestType(
  ANALYTICS_FEATURE_METRICS,
);
export const ANALYTICS_FEATURE_METRICS_SUCCESS = util.successType(
  ANALYTICS_FEATURE_METRICS,
);
export const ANALYTICS_FEATURE_METRICS_FAILURE = util.failureType(
  ANALYTICS_FEATURE_METRICS,
);
